/**
 * Crea un servicio de puntuacion con el adaptador de storage proporcionado.
 * @param {Object} storageAdapter - Debe implementar getItem(key), setItem(key, value).
 *   Los metodos pueden devolver Promises (async) o valores directos (sync).
 */
function createScoreService(storageAdapter) {
  const SCORE_KEY = "user_score";

  return {
    async getScore() {
      try {
        const score = await storageAdapter.getItem(SCORE_KEY);
        return score ? parseInt(score, 10) : 0;
      } catch (error) {
        console.error("Error getting score:", error);
        return 0;
      }
    },

    async addScore(points) {
      try {
        const currentScore = await this.getScore();
        const newScore = currentScore + points;
        await storageAdapter.setItem(SCORE_KEY, newScore.toString());
        return newScore;
      } catch (error) {
        console.error("Error adding score:", error);
        return await this.getScore();
      }
    },

    async resetScore() {
      try {
        await storageAdapter.setItem(SCORE_KEY, "0");
        return 0;
      } catch (error) {
        console.error("Error resetting score:", error);
        return 0;
      }
    },
  };
}

module.exports = { createScoreService };
